export const useProtectedRoute = () => {
  const token = localStorage.getItem('auth_token');
  return { token };
};
